import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { PrimaryContactEntityHttpClient } from './primary-contact.http-client';
import { PrimaryContactEntityActions } from './primary-contact.store';

@Injectable({ providedIn: 'root' })
export class PrimaryContactEntityEffects {
  public effects = createEffectFactory(PrimaryContactEntityActions, this.actions$);

  public fetchPrimaryContact$ = this.effects(PrimaryContactEntityActions.fetch, () =>
    this.http.fetch(),
  );

  public updatePrimaryContact$ = this.effects(PrimaryContactEntityActions.update, ({ payload }) =>
    this.http.update(payload.data, payload.isCreate),
  );

  constructor(
    private actions$: Actions,
    private http: PrimaryContactEntityHttpClient,
  ) {}
}
